// import goinShopping from "./smaller-works/goin-shopping.jpg";
// import jollyDays from "./smaller-works/jolly-days.jpg";
// import onAString from "./smaller-works/on-a-string.jpg";
// import tributeToWK from "./smaller-works/tribute-to-wk.jpg";
// import birdiSmall from "./smaller-works-small/birdi-small.jpg";
// import burdenSmall from "./smaller-works-small/burden-small.jpg";
// import goinShoppingSmall from "./smaller-works-small/goin-shopping-small.jpg";
// import jollyDaysSmall from "./smaller-works-small/jolly-days-small.jpg";
// import onAStringSmall from "./smaller-works-small/on-a-string-small.jpg";
// import tributeToWKSmall from "./smaller-works-small/tribute-to-wk-small.jpg";
// import birdi from "./smaller-works/birdi.jpg";
// import burden from "./smaller-works/burden.jpg";
import birdsAndUrnsSmall from "./smaller-works-small/birds-and-urns-small.jpg";
import caringSmall from "./smaller-works-small/caring-small.jpg";
import dontKnowWhereDontKnowWhenSmall from "./smaller-works-small/dont-know-where-dont-know-when-small.jpg";
import dotsOnRedSmall from "./smaller-works-small/dots-on-red-small.jpg";
import exaltedSmall from "./smaller-works-small/exalted-small.jpg";
import familyOnTourSmall from "./smaller-works-small/family-on-tour-small.jpg";
import griefSmall from "./smaller-works-small/grief-small.jpg";
import lilacSmall from "./smaller-works-small/lilac-small.jpg";
import morningMistSmall from "./smaller-works-small/morning-mist-small.jpg";
import morningMoodSmall from "./smaller-works-small/morning-mood-small.jpg";
import myriadesSmall from "./smaller-works-small/myriades-small.jpg";
import passiarInYellowLandscapeSmall from "./smaller-works-small/passiar-in-yellow-landscape-small.jpg";
import redFlowerSmall from "./smaller-works-small/red-flower-small.jpg";
import stonehouseSmall from "./smaller-works-small/stonehouse-small.jpg";
import summerLandScapeSmall from "./smaller-works-small/summer-landscape-small.jpg";
import theLastDaisySmall from "./smaller-works-small/the-last-daisy-small.jpg";
import twilightSmall from "./smaller-works-small/twilight-small.jpg";
import unfinishedLandscapeSmall from "./smaller-works-small/unfinished-landscape-small.jpg";
import birdsAndUrns from "./smaller-works/birds-and-urns.jpg";
import caring from "./smaller-works/caring.jpg";
import dontKnowWhereDontKnowWhen from "./smaller-works/dont-know-where-dont-know-when.jpg";
import dotsOnRed from "./smaller-works/dots-on-red.jpg";
import exalted from "./smaller-works/exalted.jpg";
import familyOnTour from "./smaller-works/family-on-tour.jpg";
import grief from "./smaller-works/grief.jpg";
import inTheKingdomOfColor5 from "./smaller-works/in-the-kingdom-of-color-5.jpg";
import inTheKingdomOfColor6 from "./smaller-works/in-the-kingdom-of-color-6.jpg";
import inTheKingdomOfColor7 from "./smaller-works/in-the-kingdom-of-color-7.jpg";
import lilac from "./smaller-works/lilac.jpg";
import morningMist from "./smaller-works/morning-mist.jpg";
import morningMood from "./smaller-works/morning-mood.jpg";
import myriades from "./smaller-works/myriades.jpg";
import passiarInYellowLandscape from "./smaller-works/passiar-in-yellow-landscape.jpg";
import redFlower from "./smaller-works/red-flower.jpg";
import stonehouse from "./smaller-works/stonehouse.jpg";
import summerLandScape from "./smaller-works/summer-landscape.jpg";
import theLastDaisy from "./smaller-works/the-last-daisy.jpg";
import twilight from "./smaller-works/twilight.jpg";
import unfinishedLandscape from "./smaller-works/unfinished-landscape.jpg";

export const smallerWorks = [
  {
    title: "The Last Daisy",
    date: "2018",
    size: "20x30",
    imageUrl: theLastDaisy,
    imageUrlSmall: theLastDaisySmall,
  },
  {
    title: "Don't know where, don't know when",
    date: "2018",
    size: "20x30",
    imageUrl: dontKnowWhereDontKnowWhen,
    imageUrlSmall: dontKnowWhereDontKnowWhenSmall,
  },
  {
    title: "Stonehouse",
    date: "2018",
    size: "20x30",
    imageUrl: stonehouse,
    imageUrlSmall: stonehouseSmall,
    sold: true,
  },
  {
    title: "Lilac",
    date: "2018",
    size: "20x30",
    imageUrl: lilac,
    imageUrlSmall: lilacSmall,
  },
  {
    title: "Family on Tour",
    date: "2023",
    size: "20x30",
    imageUrl: familyOnTour,
    imageUrlSmall: familyOnTourSmall,
  },
  {
    title: "Summer Landscape",
    date: "2022",
    size: "20x30",
    imageUrl: summerLandScape,
    imageUrlSmall: summerLandScapeSmall,
  },
  {
    title: "Red Flower",
    date: "2023",
    size: "30x20",
    imageUrl: redFlower,
    imageUrlSmall: redFlowerSmall,
  },
  {
    title: "Myriades",
    date: "2023",
    size: "30x20",
    imageUrl: myriades,
    imageUrlSmall: myriadesSmall,
  },
  {
    title: "Exalted",
    date: "2023",
    size: "30x20",
    imageUrl: exalted,
    imageUrlSmall: exaltedSmall,
  },
  {
    title: "Dots on Red",
    date: "2012",
    size: "30x30",
    imageUrl: dotsOnRed,
    imageUrlSmall: dotsOnRedSmall,
  },
  {
    title: "Birds and Urns",
    date: "2023",
    size: "30x30",
    imageUrl: birdsAndUrns,
    imageUrlSmall: birdsAndUrnsSmall,
    sold: true,
  },
  {
    title: "Passiar in Yellow Landscape",
    date: "2023",
    size: "30x30",
    imageUrl: passiarInYellowLandscape,
    imageUrlSmall: passiarInYellowLandscapeSmall,
  },
  {
    title: "Morning Mist",
    date: "2018",
    size: "30x30",
    imageUrl: morningMist,
    imageUrlSmall: morningMistSmall,
    sold: true,
  },
  {
    title: "Morning Mood",
    date: "2017",
    size: "30x30",
    imageUrl: morningMood,
    imageUrlSmall: morningMoodSmall,
    sold: true,
  },
  {
    title: "Unfinished Landscape",
    date: "2023",
    size: "20x20",
    imageUrl: unfinishedLandscape,
    imageUrlSmall: unfinishedLandscapeSmall,
  },
  {
    title: "Caring",
    date: "2020",
    size: "20x20",
    imageUrl: caring,
    imageUrlSmall: caringSmall,
  },
  {
    title: "Grief",
    date: "2021",
    size: "20x20",
    imageUrl: grief,
    imageUrlSmall: griefSmall,
  },
  {
    title: "Twilight",
    date: "2021",
    size: "20x20",
    imageUrl: twilight,
    imageUrlSmall: twilightSmall,
  },
  {
    title: "In the Kingdom of Color V",
    date: "2025",
    size: "30x40",
    imageUrl: inTheKingdomOfColor5,
    imageUrlSmall: inTheKingdomOfColor5,
  },
  {
    title: "In the Kingdom of Color VI",
    date: "2025",
    size: "30x40",
    imageUrl: inTheKingdomOfColor6,
    imageUrlSmall: inTheKingdomOfColor6,
    sold: true,
  },
  {
    title: "In the Kingdom of Color VII",
    date: "2025",
    size: "30x40",
    imageUrl: inTheKingdomOfColor7,
    imageUrlSmall: inTheKingdomOfColor7,
  },
];

// {
//   title: "Goin' Shopping",
//   date: "2021",
//   size: "20x20",
//   imageUrl: goinShopping,
//   imageUrlSmall: goinShoppingSmall,
// },
// {
//   title: "Burden",
//   date: "2023",
//   size: "20x20",
//   imageUrl: burden,
//   imageUrlSmall: burdenSmall,
// },
// {
//   title: "Tribute to WK",
//   date: "2021",
//   size: "20x20",
//   imageUrl: tributeToWK,
//   imageUrlSmall: tributeToWKSmall,
// },
// {
//   title: "Jolly Days",
//   date: "2021",
//   size: "20x20",
//   imageUrl: jollyDays,
//   imageUrlSmall: jollyDaysSmall,
// },
// {
//   title: "On a String",
//   date: "2021",
//   size: "20x20",
//   imageUrl: onAString,
//   imageUrlSmall: onAStringSmall,
// },
